import React from 'react';
import CinematicHero from './components/CinematicHero';
import SocialProofStrip from './components/SocialProofStrip';
import CoreValueBlocks from './components/CoreValueBlocks';
import EnterpriseIntegrations from './components/EnterpriseIntegrations';
import FeaturesDeepDive from './components/FeaturesDeepDive';
import PlatformDemo from './components/PlatformDemo';
import PricingSection from './components/PricingSection';
import AboutUsSection from './components/AboutUsSection';
import EnterpriseFooter from './components/EnterpriseFooter';

const EnterpriseLandingPage = () => {
  return (
    <div className="min-h-screen bg-[#0F0F11]">
      <CinematicHero />
      <SocialProofStrip />
      <CoreValueBlocks />
      <EnterpriseIntegrations />
      <FeaturesDeepDive />
      <PlatformDemo />
      <PricingSection />
      <AboutUsSection />
      <EnterpriseFooter />
    </div>
  );
};

export default EnterpriseLandingPage;